<style lang="scss">
@import './chart-move.scss';
</style>
<template>
    <!-- 图表 -->
    <div>
      <div class='funnel-chart'>
          <div class='funnel-chart-charts'>
              <Spin v-show='spinShow' fix>
                  <Icon type="ios-loading" size=18 class='demo-spin-icon-load'></Icon>
                  <div>Loading</div>
              </Spin>
              <div class="funnel-chart-charts-c" ref="area"></div>
          </div>
      </div>
      <!-- 表格 -->
      <div class="funnel-table">
          <i-table
              :columns="tableColumn"
              :data="tableData"
              :no-data-text="noData"
              ref="table"></i-table>
      </div>
    </div>
</template>
<script>
import echarts from 'echarts';
import bus from '../../libs/bus';
import ln from '../../libs/locale';

export default {
  data() {
    return {
      myChart: '',
      spinShow: true,
      chartData: {
        name: [],
        series: [],
      },
      tableData: [],
      tableColumn: [],
      noData: ln[bus.lang].common.loading,
    };
  },
  mounted() {
    const self = this;
    bus.$on('on-platform-change', () => {
      self.resizeChart();
    });
    bus.$on('on-conditions-change', () => {
      self.resizeChart();
    });
    bus.$on('on-date-change', () => {
      self.resizeChart();
    });
    window.addEventListener('resize', this.myChartResize, false);
  },
  beforeDestroy() {
    const self = this;
    window.removeEventListener('resize', self.myChartResize, false);
    if (self.myChart) {
      self.myChart.dispose();
    }
  },
  methods: {
    myChartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    resizeChart() {
      if (this.chartData.series.length > 0) this.initChart(this.chartData);
    },
    // 图表渲染
    initChart(val) {
      this.myChart = echarts.init(this.$refs.area);
      const option = {
        color: ['#1495EB'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#FFF',
          borderColor: '#C3CBD6',
          borderWidth: 1,
          axisPointer: {
            lineStyle: {
              color: '#C3CBD6',
            },
          },
          padding: [0, 10],
          formatter(a) {
            const formatterStr = `<p class='formatter-content'>
                                    <span>${a[0].name}</span>
                                    <b>${a[0].value} %</b>
                                </p>`;
            return formatterStr;
          },
        },
        grid: {
          left: 10,
          right: 8,
          bottom: 5,
          top: 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9',
              },
            },
            data: val.name,
          },
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 105,
            interval: 15,
            axisLabel: {
              formatter: '{value} %',
              textStyle: {
                color: '#7F8B9C',
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#FFFFFF',
                width: 2,
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9',
              },
            },
          },
        ],
        series: val.series,
      };
      if (!this.myChart.isDisposed()) {
        this.spinShow = false;
        this.myChart.setOption(option);
      }
    },
    // 清空数据
    clearData() {
      const self = this;
      self.spinShow = true;
      self.chartData = {
        name: [],
        series: [],
      };
      self.tableData = [];
      self.tableColumn = [];
      self.noData = ln[bus.lang].common.loading;
    },
    // 下载表格
    exportTable(name) {
      const data = JSON.parse(this.saveTableData);
      const columns = this.tableColumn.filter(x => x.type !== 'index');
      if (this.$refs.table) {
        this.$refs.table.exportCsv({
          filename: `${name}${bus.selectedDate[0]}~${bus.selectedDate[1]}`,
          columns,
          data,
        });
      }
    },
  },
};
</script>
